<template>
  <m-card v-bind="$attrs" v-on="$listeners" :edit="false" :footer="footer" no-padding class="ma-1 elevation-2">
    <template v-slot:action_ext>
      <slot name="action_ext"></slot>
    </template>
    <v-row wrap>
      <v-col cols="12" class="my-0 py-0">
        <slot name="filter"></slot>
      </v-col>
      <v-col cols="12" class="mt-4 pt-2">
        <v-data-table
          :show-select="selectAll"
          :items="items"
          no-data-text="Data Tidak Tersedia"
          :sort-by="idKey"
          v-model="selection"
          :items-per-page="perPage"
          :item-key="itemKey"
          :show-expand="expand"
          :single-expand="true"
          class="elevation-0 fix_td"
          hide-default-footer
          :hide-default-header="!headers || headers.length == 0"
          :headers="headers"
        >
          <template v-slot:top>
            <slot name="top"></slot>
          </template>
          <template v-slot:item="props">
            <v-row class="mx-3 my-1 py-1">
              <template v-for="field in gridConfig">
                <v-col
                  v-if="!field.conditional ? true : field.conditional.vIf ? field.conditional.vIf(props.item) : field.conditional.cond"
                  :key="field.index"
                  :cols="field.cols"
                  :sm="field.sm"
                  :md="field.md"
                  :lg="field.lg"
                  :xl="field.xl"
                >
                  <template v-if="field.header">
                    <span v-if="!field.conditional ? true : field.conditional.vIf ? field.conditional.vIf(props.item) : field.conditional.cond" class="caption grey--text">
                      {{ field.header }}</span
                    >
                  </template>
                  <template v-if="field.type == 'icon'">
                    <v-avatar v-bind="field.avatar">
                      <v-icon v-if="field.icon" class="secondary--text">{{ field.icon }}</v-icon>
                      <v-img v-else-if="field.src" :src="field.src"></v-img>
                      <v-img v-else :src="props.item.cover || 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/bg-success.jpg'"></v-img>
                    </v-avatar>
                  </template>
                  <template v-else-if="field.type == 'string'">
                    <p v-if="!field.conditional ? true : field.conditional.vIf ? field.conditional.vIf(props.item) : field.conditional.cond" :class="field.class + ' py-0 my-0'">
                      {{ field.name ? wrapObj(field.name, props.item) : field.text }}
                    </p>
                  </template>
                  <p v-else-if="field.type == 'singledate'" :class="field.class + ' py-0 my-0'">
                    <span v-if="field.filter == 'toD'">{{ wrapObj(field.name, props.item) | toD }}</span>
                    <span v-else>{{ wrapObj(field.name, props.item) | toDT }}</span>
                  </p>
                  <p v-else-if="field.type == 'doubledate'" :class="field.class + ' py-0 my-0'">
                    <label>{{ field.labelFrom }}</label
                    ><br />
                    {{ wrapObj(field.from, props.item) | toDT }} s/d <br />
                    <label>{{ field.labelTo }}</label
                    ><br />
                    {{ wrapObj(field.to, props.item) | toDT }}
                  </p>
                  <p v-else-if="field.type == 'button'" :class="field.class + ' py-0 my-0'">
                    <m-button
                      :icon="field.button.icon"
                      :isBlock="field.button.block"
                      :disabled="field.button.disabled"
                      depressed
                      :color="field.button.color"
                      :textButton="field.button.text"
                      action="toAction"
                      @toAction="$emit('toAction', props.item)"
                    ></m-button>
                  </p>
                  <p v-if="field.type == 'label'" class="py-0 my-0">
                    <span :class="field.statusColor.statusColor(props.item[field.name]) + '--text'">{{
                      field.keterangan ? cVal(props.item, field.keterangan) : pVal(props.item.status_kelas, "keterangan")
                    }}</span>
                  </p>
                  <p v-if="field.type == 'customLabel'" class="py-0 my-0">
                    {{ props.item[field.name]["keterangan"] }}
                  </p>
                  <template v-if="field.type == 'status'">
                    <p class="py-0 my-0">
                      <span :class="field.statusColor.statusColor(props.item[field.name]) + '--text'">{{ cVal(props.item, field.keterangan) }}</span>
                    </p>
                  </template>
                  <p v-if="field.type == 'more'" class="py-0 my-0">
                    <m-menu right class="clearfix" style="float: right" :items="field.more" :object="props.item" />
                  </p>
                  <template v-if="field.items">
                    <div v-for="subItem in field.items" :key="subItem.index">
                      <p v-if="subItem.type == 'label'" class="py-0 my-0">
                        <span :class="subItem.statusColor.statusColor(wrapObj(subItem.name, props.item)) + '--text'">{{
                          subItem.labelStatus.statusColor(wrapObj(subItem.name, props.item))
                        }}</span>
                      </p>
                      <p v-else>{{ wrapObj(subItem.name, props.item) }}</p>
                    </div>
                  </template>
                </v-col>
              </template>
            </v-row>
            <v-divider></v-divider>
          </template>
          <template v-slot:expanded-item="props">
            <slot name="detail" :props="props" :item="props.item"></slot>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <template v-slot:footer>
      <v-row wrap class="pb-3" v-if="page && page.last_page > 1">
        <v-col :cols="$vuetify.breakpoint.smAndUp ? 2 : 3" class="text-left" align="center" justify="center">
          <p class="caption font-weight-bold">{{ page.total }} &nbsp; Data ditemukan</p>
        </v-col>
        <v-col cols="8" v-if="$vuetify.breakpoint.smAndUp" class="text-center">
          <v-pagination v-if="page.total" :key="page_key" v-model="current_page" :length="page.last_page" :total-visible="7" @input="change"></v-pagination>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndUp ? 2 : 9" v-if="page.from" class="text-right">
          <p class="caption font-weight-bold">{{ page.from }} - {{ page.to }} dari {{ page.total }}</p>
        </v-col>
      </v-row>
    </template>
  </m-card>
</template>

<script>
// @group Global Component
export default {
  inheritAttrs: false,
  name: "m-card-list",
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    gridConfig: {
      type: Array,
      default: () => [
        {
          align: "left",
          name: "kode",
          type: "string",
          cols: 12,
          sm: 12,
          md: 12,
          lg: 12
        }
      ]
    },
    avatarIcon: {
      type: String,
      default: "fa-chalkboard"
    },
    threeLine: {
      type: Boolean,
      default: false
    },
    expand: {
      type: Boolean,
      default: false
    },
    twoLine: {
      type: Boolean,
      default: false
    },
    idKey: {
      type: String,
      default: "id"
    },
    titleKey: {
      type: String,
      default: ""
    },
    subTitle1Key: {
      type: String,
      default: ""
    },
    subTitle2Key: {
      type: String,
      default: ""
    },
    edit: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    },
    page: {
      type: Object,
      default: null
    },
    perPage: {
      type: Number,
      default: 15
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    value: {},
    itemKey: {
      type: String,
      default: "id"
    }
  },
  data: () => ({
    current_page: 0,
    jump_page: 0,
    selection: [],
    pagging: {},
    page_key: 0
  }),
  methods: {
    change() {
      if (this.current_page !== this.page.current_page) {
        this.$emit("change:page", this.current_page);
      }
    },
    jump() {
      if (Number.isInteger(this.jump_page)) {
        this.$emit("change:page", this.jump_page);
      }
    },
    wrapObj(path, obj) {
      var context = obj || this;
      path = path.split(".");

      for (var i = 0; i < path.length; i++) {
        context = context[path[i]];
      }

      return context;
    },
    cVal(obj, a) {
      if (obj[a] == 0) {
        return "DRAFT";
      } else if (obj[a] == 1) {
        return "TERBIT";
      }
    }
  },
  created() {
    this.current_page = this.page ? this.page.current_page : 0;
    this.jump_page = this.page ? this.page.current_page : 1;
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
      }
    },
    value(n) {
      this.selection = n;
    },
    items() {
      this.current_page = this.page ? this.page.current_page : 0;
    },
    selection(n) {
      this.$emit("input", n);
    }
  }
};
</script>

<style></style>
